import { AggregatedArticle } from "@coworker/app/src/components/RoomSettings/hooks/useAggregatedArticles";
import { EdsData } from "@coworker/app/src/components/RoomSettings/types/article";
import { Media } from "@coworker/app/src/components/RoomSettings/types/media";
import { ItemDelete } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/ItemDelete/ItemDelete";
import { ItemEditQuantity } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/ItemEditQuantity/ItemEditQuantity";
import { MediaItemCardWithActions } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/MediaItemCardWithActions/MediaItemCardWithActions";
import { MediaItemViewType } from "@coworker/apprestructured/src/media-maintenance/types/mediaItemViewType";
import { Spacer } from "@coworker/apprestructured/src/shared/components/Spacer/Spacer";
import { ItemStockInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemStock";
import { ItemBadge } from "@coworker/apprestructured/src/shared/types/ItemBadge";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { ItemCardRenderType } from "@coworker/apprestructured/src/shared/types/itemCardRenderType";
import styles from "../../../styles/common-media-styles.module.css";

type MediaItemCardInGroupsBaseProps<T extends AggregatedArticle> = {
  article: T;
  item: Item;
  edsData?: EdsData | null;
  badges: ItemBadge[];
  itemCardRenderType?: ItemCardRenderType;
  mediaItemViewType?: MediaItemViewType;
  shouldDisplayQuantity?: boolean;
  totalQuantityPieces?: number;
  stockInfo?: ItemStockInfo;
};

type MediaItemCardInGroupsProps<T extends AggregatedArticle> =
  | (MediaItemCardInGroupsBaseProps<T> & { showActions?: false; media?: Media })
  | (MediaItemCardInGroupsBaseProps<T> & { showActions: true; media: Media });

export const MediaItemCardInGroups = <T extends AggregatedArticle>(
  props: MediaItemCardInGroupsProps<T>
) => {
  const {
    item,
    article,
    showActions = false,
    edsData,
    badges,
    itemCardRenderType = ItemCardRenderType.link,
    mediaItemViewType = MediaItemViewType.AGGREGATED_ITEM_VIEW,
    shouldDisplayQuantity = true,
    totalQuantityPieces: totalQuantityPiecesProp,
    stockInfo,
  } = props;
  const media = showActions ? props.media : undefined;
  const totalQuantityPieces =
    totalQuantityPiecesProp ??
    article.aggregatedArticles.reduce((acc, a) => acc + a.nbrArticles, 0);
  return (
    <MediaItemCardWithActions
      mediaItemViewType={mediaItemViewType}
      itemCardRenderType={itemCardRenderType}
      item={item}
      edsData={edsData ?? null}
      article={article}
      stockInfo={stockInfo}
      badges={badges || []}
      shouldDisplayQuantity={shouldDisplayQuantity}
      totalQuantityPieces={totalQuantityPieces}
      renderActions={() =>
        showActions && media ? (
          <>
            <Spacer />
            <div className={styles["item-card-action-row"]}>
              <ItemEditQuantity media={media} article={article} />
              <ItemDelete
                itemNo={article.productArticleId}
                isItemInMultipleGroups={true}
                article={article}
                media={media}
              />
            </div>
          </>
        ) : null
      }
    />
  );
};
